import { pushNewView, updateSelectedCalendarEvent } from '../actions/timePanelStoreActions';
import { clickCalendarEvent, doubleClickCalendarEvent } from 'owa-conflicts-view';
import { orchestrator } from 'satcheljs';

export const clickCalendarEventOrchestrator = orchestrator(clickCalendarEvent, actionMessage => {
    updateSelectedCalendarEvent(actionMessage.id);
    pushNewView('EventDetails');
});

export const doubleClickCalendarEventOrchestrator = orchestrator(
    doubleClickCalendarEvent,
    actionMessage => {
        updateSelectedCalendarEvent(actionMessage.id);
        pushNewView('EventDetails');
    }
);
